export default "__VITE_ASSET__fef4ee20__"